























































import Vue from 'vue';
import moment from 'moment';
import PlaylistStudentThumbnail from '@/web/components/playlists/PlaylistStudentThumbnail';
import HMTag from '@/web/components/common/HMTag';
import StudioPlaylistMediaTag from '@/web/views/shop/StudioPlaylistMediaTag';

export default Vue.extend({
  name: 'PlaylistStudentItemCard',
  props: {
    playlist: {
      type: Object as () => PlaylistResponse,
      required: true,
    },
    review: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PlaylistStudentThumbnail,
    HMTag,
    StudioPlaylistMediaTag,
  },
  computed: {
    instructors() {
      const instructorsMap = new Map();
      this.playlist.content.forEach(item => {
        if (item.instructor) {
          instructorsMap.set(item.instructor.id, item.instructor);
        }
      });
      return [...instructorsMap.values()];
    },
    getMediaCountText() {
      return `${this.playlist.content.length}
				${this.$tc('PRODUCTS.TEXT.ITEMS_VARIANT', this.playlist.content.length)}`;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MMM DD, yyyy');
    },
    redirectToPlaylistDetail() {
      this.$router.push({
        name: 'studio-playlist',
        params: {
          product_id: this.$route.params.product_id,
          playlist_id: this.playlist.id,
        },
      });
    },
  },
});
